import { useScrollAnimation } from '@/hooks/useScrollAnimation';

export default function MidPageCTA() {
  const { ref, visible } = useScrollAnimation();

  return (
    <section ref={ref} className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/c437dfad627eef44125c508be37d7bb8.jpg"
          alt="Austin TX commercial signage"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-[#080808]/88" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8 py-20">
        <div className={`flex flex-col lg:flex-row items-center justify-between gap-10 reveal ${visible ? 'visible' : ''}`}>
          <div className="text-center lg:text-left">
            <p className="eyebrow mb-4">Ready to Stand Out?</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-4"
              style={{ fontFamily: 'Playfair Display, serif' }}>
              Your Competitors Are Already<br />
              <span className="text-gradient-gold">Investing in Signage</span>
            </h2>
            <p className="text-white/50 text-base max-w-lg">
              Don&apos;t let your business blend into the background. Get a professionally engineered sign that commands attention and drives real foot traffic.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 flex-shrink-0">
            <a href="#quote" className="btn-gold whitespace-nowrap">
              Get a Free Quote
              <i className="ri-arrow-right-line" />
            </a>
            <a href="tel:+15127990115" className="btn-outline-white whitespace-nowrap">
              <i className="ri-phone-fill" />
              Call Now
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
